<template>
  <b-modal 
    id="modal-verifikasi-rekening-kasir" 
    title="Konfirmasi Manual Rekening" 
    centered 
    :no-close-on-backdrop="isLoading"
    :no-close-on-esc="isLoading"
    :hide-header-close="isLoading"
  >
    <div class="mb-4">
      <b-alert show variant="warning" class="text-dark">
        <h6 class="alert-heading mb-1">Perhatian!</h6>
        Sistem mendeteksi perbedaan nama. Pastikan nama pemilik rekening tidak berbeda jauh dari nama anggota.
      </b-alert>
    </div>

    <b-row class="mb-2">
      <b-col cols="12" sm="5" class="text-muted mb-1 mb-sm-0">Nama Anggota</b-col>
      <b-col cols="12" sm="7" class="font-weight-bold">
        <span class="d-none d-sm-inline">: </span>{{ namaAnggota }}
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col cols="12" sm="5" class="text-muted mb-1 mb-sm-0">Nama Pemilik Rekening</b-col>
      <b-col cols="12" sm="7" class="font-weight-bold">
        <span class="d-none d-sm-inline">: </span>{{ namaRekening }}
      </b-col>
    </b-row>

    <p class="mt-4 mb-0">Apakah data rekening ini sesuai / masih bisa ditoleransi?</p>

    <template #modal-footer>
      <b-button 
        variant="secondary" 
        @click="$emit('reject')"
        :disabled="isLoading"
      >
        Tidak Sesuai
      </b-button>

      <b-button 
        variant="primary" 
        @click="$emit('submit')"
        :disabled="isLoading"
      >
        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
        Ya, Lanjutkan
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalVerifikasiRekeningKasir',
  props: {
    namaAnggota: {
      type: String,
      default: '-'
    },
    namaRekening: {
      type: String,
      default: '-'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>